/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-09 14:27:25
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-15 10:47:49
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Plane/index.ts
 */
import type { SceneControl } from '@anov/3d-core'
import type { MeshBasicMaterialParameters } from '@anov/3d-core'
import {
  Mesh,
  MeshBasicMaterial,
  PlaneGeometry,
} from '@anov/3d-core'
import _ from 'lodash'
import ObjectLayer from '../Base/ObjectLayer'
import { defineProps } from '../Utils/defineProps'
import type { IPlane } from './interface'
import type { options } from './types'

export class Plane extends ObjectLayer implements IPlane {
  private mesh!: Mesh
  private currentOptions!: options
  constructor(options: options, sceneControl: SceneControl) {
    super(sceneControl)
    this.currentOptions = options
    this.mesh = this.createPlane(options)
    this.add(this.mesh)
    defineProps(
      this,
      ['width', 'length', 'widthSegment', 'lengthSegment'],
      ['wireframe', 'color'],
      'updatePlane',
    )
  }

  public createPlane(options: options): Mesh {
    const {
      length = 1,
      width = 1,
      lengthSegment = 1,
      widthSegment = 1,
      material = {},
    } = options

    // 默认材质参数
    const defaultMat: MeshBasicMaterialParameters = {
      color: 0xFFFFFF,
      opacity: 1,
      transparent: false,
      wireframe: false,
      visible: true,
      side: 2,
    }
    const geometry = new PlaneGeometry(width, length, widthSegment, lengthSegment)
    const mat = new MeshBasicMaterial({ ...defaultMat, ...material })
    return new Mesh(geometry, mat)
  }

  updatePlane(options: options): void {
    if (!this.mesh)
      return
    _.mergeWith(this.currentOptions, options)
    this.remove(this.mesh)
    this.mesh.geometry.dispose();
    (this.mesh.material as any).dispose()
    this.mesh = this.createPlane(this.currentOptions)
    this.add(this.mesh)
  }

  /** 销毁释放资源 */
  public destroy() {
    if (!this.mesh)
      return
    this.remove(this.mesh)
    this.mesh.geometry.dispose()
    ; (this.mesh.material as any).dispose()
    // @ts-ignore
    this.mesh = null
  }
}
